/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentConcernModal } from './AppointmentConcernModal';
import {
    AppointmentConcernModalFromJSON,
    AppointmentConcernModalFromJSONTyped,
    AppointmentConcernModalToJSON,
} from './AppointmentConcernModal';
import type { AppointmentConcernRestriction } from './AppointmentConcernRestriction';
import {
    AppointmentConcernRestrictionFromJSON,
    AppointmentConcernRestrictionFromJSONTyped,
    AppointmentConcernRestrictionToJSON,
} from './AppointmentConcernRestriction';
import type { AppointmentDeliveryOption } from './AppointmentDeliveryOption';
import {
    AppointmentDeliveryOptionFromJSON,
    AppointmentDeliveryOptionFromJSONTyped,
    AppointmentDeliveryOptionToJSON,
} from './AppointmentDeliveryOption';
import type { BookingOptionFee } from './BookingOptionFee';
import {
    BookingOptionFeeFromJSON,
    BookingOptionFeeFromJSONTyped,
    BookingOptionFeeToJSON,
} from './BookingOptionFee';
import type { FollowUpConcern } from './FollowUpConcern';
import {
    FollowUpConcernFromJSON,
    FollowUpConcernFromJSONTyped,
    FollowUpConcernToJSON,
} from './FollowUpConcern';
import type { PatientClearance } from './PatientClearance';
import {
    PatientClearanceFromJSON,
    PatientClearanceFromJSONTyped,
    PatientClearanceToJSON,
} from './PatientClearance';

/**
 * 
 * @export
 * @interface AppointmentConcern
 */
export interface AppointmentConcern {
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    minutes: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    capacity_duration_minutes?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    max_simultaneous_appointments?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    only_subscribers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    only_primary_physician?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    ai_prompt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    skip_reason?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    reason_text?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    communication_text?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    allow_empty_reason?: boolean;
    /**
     * 
     * @type {AppointmentConcernModal}
     * @memberof AppointmentConcern
     */
    modal?: AppointmentConcernModal;
    /**
     * 
     * @type {Array<BookingOptionFee>}
     * @memberof AppointmentConcern
     */
    fees?: Array<BookingOptionFee>;
    /**
     * 
     * @type {Array<AppointmentConcernRestriction>}
     * @memberof AppointmentConcern
     */
    restrictions?: Array<AppointmentConcernRestriction>;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    above_age_months?: number;
    /**
     * 
     * @type {number}
     * @memberof AppointmentConcern
     */
    below_age_months?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    gender?: AppointmentConcernGenderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    annual?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    not_first_appointment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    supertype?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    unable_to_book_message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    skills?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    clinics?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    physician_types?: Array<string>;
    /**
     * 
     * @type {FollowUpConcern}
     * @memberof AppointmentConcern
     */
    follow_up_concern?: FollowUpConcern;
    /**
     * 
     * @type {string}
     * @memberof AppointmentConcern
     */
    color_on_schedule?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AppointmentConcern
     */
    hidden_from_patient?: boolean;
    /**
     * How long until the appointment is automaically marked no show
     * @type {number}
     * @memberof AppointmentConcern
     */
    cancel_cutoff?: number;
    /**
     * 
     * @type {Array<AppointmentDeliveryOption>}
     * @memberof AppointmentConcern
     */
    delivery_options?: Array<AppointmentDeliveryOption>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppointmentConcern
     */
    requirements?: Array<string>;
    /**
     * How long appointment must be spaced out in days
     * @type {number}
     * @memberof AppointmentConcern
     */
    minimum_interval?: number;
    /**
     * Clearances granted to patient upon appointment completion. Duplicated clearances are overwritten.
     * @type {Array<PatientClearance>}
     * @memberof AppointmentConcern
     */
    grants_clearances?: Array<PatientClearance>;
}


/**
 * @export
 */
export const AppointmentConcernGenderEnum = {
    Male: 'Male',
    Female: 'Female'
} as const;
export type AppointmentConcernGenderEnum = typeof AppointmentConcernGenderEnum[keyof typeof AppointmentConcernGenderEnum];


/**
 * Check if a given object implements the AppointmentConcern interface.
 */
export function instanceOfAppointmentConcern(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "minutes" in value;

    return isInstance;
}

export function AppointmentConcernFromJSON(json: any): AppointmentConcern {
    return AppointmentConcernFromJSONTyped(json, false);
}

export function AppointmentConcernFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentConcern {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'text': json['text'],
        'minutes': json['minutes'],
        'capacity_duration_minutes': !exists(json, 'capacity_duration_minutes') ? undefined : json['capacity_duration_minutes'],
        'max_simultaneous_appointments': !exists(json, 'max_simultaneous_appointments') ? undefined : json['max_simultaneous_appointments'],
        'only_subscribers': !exists(json, 'only_subscribers') ? undefined : json['only_subscribers'],
        'only_primary_physician': !exists(json, 'only_primary_physician') ? undefined : json['only_primary_physician'],
        'ai_prompt': !exists(json, 'ai_prompt') ? undefined : json['ai_prompt'],
        'skip_reason': !exists(json, 'skip_reason') ? undefined : json['skip_reason'],
        'reason_text': !exists(json, 'reason_text') ? undefined : json['reason_text'],
        'communication_text': !exists(json, 'communication_text') ? undefined : json['communication_text'],
        'allow_empty_reason': !exists(json, 'allow_empty_reason') ? undefined : json['allow_empty_reason'],
        'modal': !exists(json, 'modal') ? undefined : AppointmentConcernModalFromJSON(json['modal']),
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(BookingOptionFeeFromJSON)),
        'restrictions': !exists(json, 'restrictions') ? undefined : ((json['restrictions'] as Array<any>).map(AppointmentConcernRestrictionFromJSON)),
        'above_age_months': !exists(json, 'above_age_months') ? undefined : json['above_age_months'],
        'below_age_months': !exists(json, 'below_age_months') ? undefined : json['below_age_months'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'annual': !exists(json, 'annual') ? undefined : json['annual'],
        'not_first_appointment': !exists(json, 'not_first_appointment') ? undefined : json['not_first_appointment'],
        'supertype': !exists(json, 'supertype') ? undefined : json['supertype'],
        'unable_to_book_message': !exists(json, 'unable_to_book_message') ? undefined : json['unable_to_book_message'],
        'skills': !exists(json, 'skills') ? undefined : json['skills'],
        'clinics': !exists(json, 'clinics') ? undefined : json['clinics'],
        'physician_types': !exists(json, 'physician_types') ? undefined : json['physician_types'],
        'follow_up_concern': !exists(json, 'follow_up_concern') ? undefined : FollowUpConcernFromJSON(json['follow_up_concern']),
        'color_on_schedule': !exists(json, 'color_on_schedule') ? undefined : json['color_on_schedule'],
        'hidden_from_patient': !exists(json, 'hidden_from_patient') ? undefined : json['hidden_from_patient'],
        'cancel_cutoff': !exists(json, 'cancel_cutoff') ? undefined : json['cancel_cutoff'],
        'delivery_options': !exists(json, 'delivery_options') ? undefined : ((json['delivery_options'] as Array<any>).map(AppointmentDeliveryOptionFromJSON)),
        'requirements': !exists(json, 'requirements') ? undefined : json['requirements'],
        'minimum_interval': !exists(json, 'minimum_interval') ? undefined : json['minimum_interval'],
        'grants_clearances': !exists(json, 'grants_clearances') ? undefined : ((json['grants_clearances'] as Array<any>).map(PatientClearanceFromJSON)),
    };
}

export function AppointmentConcernToJSON(value?: AppointmentConcern | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'text': value.text,
        'minutes': value.minutes,
        'capacity_duration_minutes': value.capacity_duration_minutes,
        'max_simultaneous_appointments': value.max_simultaneous_appointments,
        'only_subscribers': value.only_subscribers,
        'only_primary_physician': value.only_primary_physician,
        'ai_prompt': value.ai_prompt,
        'skip_reason': value.skip_reason,
        'reason_text': value.reason_text,
        'communication_text': value.communication_text,
        'allow_empty_reason': value.allow_empty_reason,
        'modal': AppointmentConcernModalToJSON(value.modal),
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(BookingOptionFeeToJSON)),
        'restrictions': value.restrictions === undefined ? undefined : ((value.restrictions as Array<any>).map(AppointmentConcernRestrictionToJSON)),
        'above_age_months': value.above_age_months,
        'below_age_months': value.below_age_months,
        'gender': value.gender,
        'annual': value.annual,
        'not_first_appointment': value.not_first_appointment,
        'supertype': value.supertype,
        'unable_to_book_message': value.unable_to_book_message,
        'skills': value.skills,
        'clinics': value.clinics,
        'physician_types': value.physician_types,
        'follow_up_concern': FollowUpConcernToJSON(value.follow_up_concern),
        'color_on_schedule': value.color_on_schedule,
        'hidden_from_patient': value.hidden_from_patient,
        'cancel_cutoff': value.cancel_cutoff,
        'delivery_options': value.delivery_options === undefined ? undefined : ((value.delivery_options as Array<any>).map(AppointmentDeliveryOptionToJSON)),
        'requirements': value.requirements,
        'minimum_interval': value.minimum_interval,
        'grants_clearances': value.grants_clearances === undefined ? undefined : ((value.grants_clearances as Array<any>).map(PatientClearanceToJSON)),
    };
}

